// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"ShipmentsListView_itemContainer__3le_6","rowWrapToColumn":"ShipmentsListView_rowWrapToColumn__36DJ5","noRowsToShow":"ShipmentsListView_noRowsToShow__3SzN2"};